"use client";

import { FC } from "react";

import RentalCarDatesRangeInput from "./RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "./RentalCarTimesRangeInput";

import { useData } from "data/data-provider";
import LocationInput from "../LocationInput";
import DropOffLocationInput from "../DropOffLocationInput";
import { LOCATION_COPY, DROP_OFF_TOGGLE } from "config/locationCopy";

export interface RentalCarSearchFormProps {}

const RentalCarSearchForm: FC<RentalCarSearchFormProps> = () => {
  const {
    setPickupLocation,
    setDropoffLocation,
    setSearchedPickupLocation,
    setSearchedDropoffLocation,
    pickupLocation,
    dropOffLocation,
    setDropoffLocationType,
    setSameDropoffLocation,
    dropoffLocationType,
    ourLocation,
  } = useData();

 const hasDropoffLocations = ourLocation.some(
    (loc) =>
      loc.active !== false &&
      (loc.location_type === "drop_off" || loc.location_type === "both")
  );

  const renderRadioBtn = () => {
    return (
      <div className=" [ nc-hero-field-padding ] flex items-center flex-wrap flex-row border-b border-secondary-100">
        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-xs cursor-pointer mr-2 sm:mr-3 ${
            dropoffLocationType === true
              ? "bg-primary-brand  border-primary-brand text-on-primary shadow-black/10 shadow-lg"
              : " text-text-color"
          }`}
          onClick={(e) => {
            const currentLocation = pickupLocation ?? dropOffLocation;
            setDropoffLocationType(true);
            setSameDropoffLocation(true);
            setDropoffLocation(null);
            setSearchedDropoffLocation("");
            if (currentLocation) {
              setPickupLocation(currentLocation);
              setSearchedPickupLocation(currentLocation.name ?? "");
            }
          }}
        >
          {DROP_OFF_TOGGLE.same}
        </div>
        
          <div
            className={`py-1.5 px-4 flex items-center rounded-md font-medium text-xs cursor-pointer mr-2 sm:mr-3 ${
              dropoffLocationType === false
                ? "bg-primary-brand  border-primary-brand text-on-primary shadow-black/10 shadow-lg"
                : " text-text-color"
            }`}
            onClick={() => {
              setDropoffLocationType(false);
              setSameDropoffLocation(false);
              const activeLocations = ourLocation.filter((loc) => loc.active !== false);
              if (activeLocations.length === 1) {
                setPickupLocation(activeLocations[0]);
                setDropoffLocation(activeLocations[0]);
                setSearchedPickupLocation(activeLocations[0].name ?? "");
                setSearchedDropoffLocation(activeLocations[0].name ?? "");
              } else {
                setPickupLocation(null);
                setDropoffLocation(null);
                setSearchedDropoffLocation("");
                setSearchedPickupLocation("");
              }
            }}
          >
            {DROP_OFF_TOGGLE.different}
          </div>
        
      </div>
    );
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative mt-8 rounded-md shadow-xl bg-secondary-50/80 backdrop-blur-sm">
      <div className="flex flex-start ml-12"></div>
      {hasDropoffLocations &&renderRadioBtn()}
      <div className={`relative flex flex-row `}>
        <LocationInput
          labelPosition="bottom"
          placeHolder={
            isDdropOffdifferent
              ? LOCATION_COPY.pickUp.label
              : LOCATION_COPY.same.label
          }
          desc={
            isDdropOffdifferent
              ? LOCATION_COPY.pickUp.prompt
              : LOCATION_COPY.same.prompt
          }
          className="flex-1"
          sameDropOffLocation={dropoffLocationType === false}
        />
        {isDdropOffdifferent && (
          <>
            <div className="self-center border-r border-secondary-100 h-8"></div>
            <DropOffLocationInput
          labelPosition="bottom"
              placeHolder={LOCATION_COPY.dropOff.label}
              desc={LOCATION_COPY.dropOff.prompt}
              className="flex-1"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </>
        )}
        <div className="self-center border-r border-secondary-100 h-8"></div>
        <RentalCarDatesRangeInput className="flex-1" />
        <div className="self-center border-r border-secondary-100 h-8"></div>
        <RentalCarTimesRangeInput
          dropOffLocationType={dropoffLocationType}
          className="flex-2"
          design="designA"
        />
      </div>
    </form>
  );
};

export default RentalCarSearchForm;
